exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text[data-v-490c3c3a] {\n  padding: 1em;\n}\n.drag-area[data-v-490c3c3a] {\n  display: block;\n  width: 100%;\n  background-color: rgba(28, 133, 154, 0.05);\n}\n.gray[data-v-490c3c3a] {\n  background-color: rgba(28, 133, 154, 1);\n}\n.salmon[data-v-490c3c3a] {\n  background-color: rgba(28, 133, 154, 0.05);\n}\nbutton[data-v-490c3c3a] {\n  border: none;\n  background-color: #1c869a;\n  width: 49%;\n  margin: 1em auto;\n  padding: 1em;\n  color: white;\n  font-family: \"Noto Sans KR\", sans-serif;\n  text-transform: uppercase;\n}\n.underline[data-v-490c3c3a] {\n  text-decoration: underline;\n}\n", ""]);

// exports
